import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing the selfservice icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SelfServiceIcon width={12} />
 */
const SelfServiceIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M37.59,39.7l-1.94-2A18,18,0,0,1,6,24a1.8,1.8,0,1,1,3.6,0A14.4,14.4,0,0,0,33.12,35.16L31.3,
                  33.3,40,31.05ZM14.7,13A14.4,14.4,0,0,1,38.41,24,1.8,1.8,0,0,0,42,24,18,18,0,0,0,12.12,
                  10.49l-2-1.93L7.91,17.24l8.65-2.39ZM34.36,24A10.36,10.36,0,1,1,24,13.64,10.36,10.36,0,0,1,
                  34.36,24Zm-4.24-3.74-.94-.94a.7.7,0,0,0-.95,0L22.11,25.4l-2.34-2.35a.72.72,0,0,0-.95,
                  0l-.94.95a.7.7,0,0,0,0,.95l3.73,3.75a.73.73,0,0,0,.5.19.64.64,0,0,0,.47-.19l7.54-7.54A.63.63,
                  0,0,0,30.12,20.26Z`}
        />
    </SvgIcon>
)

SelfServiceIcon.defaultProps = defaultProps

export { SelfServiceIcon }
